/* @ngInject */
const myOwnerCreateForm = (
  toaster,
  $$owner
) => {
  return {
    restrict: 'E',
    scope: {
      myOwner: '=',
      enableContacts: '=?',
      enableTitle: '=?',
    },
    template: require('./myOwnerCreateForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.saveOwner = async (_owner) => {
        try {
          const response = await $$owner.request.save(_owner)
          toaster.message(response.message)
          $scope.reinit()
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinit = () => {
        $scope.myOwner = $$owner.new()
        $scope.ownerCreateForm.$setPristine()
        $scope.ownerCreateForm.$setUntouched()
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myOwnerCreateForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/directives/form/myOwnerCreateForm.js